/** Matches planned API shape; use MOCK until backend returns `working_hours` on each branch. */

export type LocalizedHoursField = { EN: string; AR: string };

export interface BranchWorkingHours {
  StartTime: LocalizedHoursField;
  EndTime: LocalizedHoursField;
  WorkingDays: LocalizedHoursField;
}

export const MOCK_BRANCH_WORKING_HOURS: BranchWorkingHours = {
  StartTime: { EN: "09:00 AM", AR: "09:00 ص" },
  EndTime: { EN: "04:00 PM", AR: "04:00 م" },
  WorkingDays: {
    EN: "Sun, Mon, Tue, Wed, Thu",
    AR: "الأحد، الإثنين، الثلاثاء، الأربعاء، الخميس",
  },
};

export function pickLocalizedHours(
  hours: BranchWorkingHours,
  language: string
): { start: string; end: string; days: string } {
  const key: "EN" | "AR" = language === "ar" ? "AR" : "EN";
  return {
    start: hours.StartTime[key],
    end: hours.EndTime[key],
    days: hours.WorkingDays[key],
  };
}

export function resolveBranchWorkingHours(
  branch: { working_hours?: BranchWorkingHours | null },
  fallback: BranchWorkingHours = MOCK_BRANCH_WORKING_HOURS
): BranchWorkingHours {
  if (
    branch?.working_hours &&
    branch.working_hours.StartTime &&
    branch.working_hours.EndTime &&
    branch.working_hours.WorkingDays
  ) {
    return branch.working_hours;
  }
  return fallback;
}
